<div class="h-screen flex-grow min-h-0 flex flex-col"> <!--[@routeAnimations]="prepareRoute(outlet)"-->
    <router-outlet #outlet="outlet">
      <div class="bg-red-500 w-screen h-screen" *ngIf="loading$ | async">
        <app-blocker [text]="'Loading restaurant' | translate"></app-blocker>
      </div>
      <div class="bg-red-500 w-screen h-screen flex justify-center items-center flex-col" *ngIf="unableToLoad$ | async">
        <div class="text-white text-2xl mb-6">{{'Loading failed'|translate}}</div>
        <img src="assets/icons/undraw_server_down_s4lk.svg" class="px-6 mb-6 max-w-screen-sm"/>
        <app-button (click)="retry()" [text]="'Try again'| translate"></app-button>
      </div>
    </router-outlet>
</div>
